export const platfromIdFromUserId = (user_id) => {
    return `${user_id}_${process.env.REACT_APP_CHAT_PLATFORM_NAME}`
}